import React, { useEffect, useState } from "react";
import InputIcon from "../components/Input/InputIcon";
import bg from "../assets/images/bg-onboarding.png";
import whatsapp from "../assets/icons/whatsapp.svg";
import mail from "../assets/icons/mail-icon.svg";
import userIcon from "../assets/icons/user-01.svg";
import Header from "../components/Header";
import { BankData } from "../data/BankData";
import _ from "lodash";
import withAuth from "../components/withAuth";
import { useAuth } from "../components/auth/authContext";
import useAPI from "../hooks/useAPI";
import { requestAuthGet, requestAuthPatch } from "../api/authInstance";
import Container from "../components/Container/Container";
import { formatPhoneNumber, toastNotify } from "../utils/Utils";
import InformationSheet from "../components/Sheet/InformationSheet";
import { useTranslation } from "react-i18next";
import Button from "../components/Button/Button";
import FormInput from "../components/Input/FormInput";
import CardSection from "../components/Card/CardSection";
import ModalLoading from "../components/ModalLoading";
import ModalConfirmation from "../components/Modal/ModalConfirmation";
import { useNavigate } from "react-router-dom";

function Profile() {
  const { userData, fetchAuthData, logout } = useAuth();
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("dompet_user")),
  );
  const [inputBank, setInputBank] = useState({});
  const navigate = useNavigate();

  const [optionsData, setOptionsData] = useState({
    outlets: [],
    banks: [],
  });
  const [isBannerShow, setIsBannerShow] = useState({
    renew_bank_data: false,
    disable_change_data: user?.user_type === "member",
  });
  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    GetAllDataRequire();
  }, []);

  async function GetAllDataRequire() {
    // validate user only user admin or master
    if (userData?.role?.walletAdmin) {
      try {
        // GET Bank Data
        await GetDataBank();
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function GetDataBank() {
    try {
      // Get data bank details
      let bank = await requestAuthGet(`/bank-account`, {
        params: { retailer: userData?.outlet?.retailer?.id },
      });
      if (bank.data.data[0]) {
        bank = bank.data.data[0];
      }
      setInputBank((prevState) => ({
        ...prevState,
        bank_account_id: bank.bank_account_id,
        bankName: bank.bankName,
        accountNumber: bank.accountNumber,
        name: bank.name,
      }));
      // SET bank options
      setOptionsData((prevState) => ({
        ...prevState,
        banks: BankData.map((value) => ({
          label: value.name,
          value: value.id,
        })),
      }));
      // set logic show banner require renew bank data
      setIsBannerShow((prevState) => ({
        ...prevState,
        renew_bank_data: _.isEmpty(
          BankData.filter((option) => option.channel_code === bank.bankName),
        ),
      }));
    } catch (error) {
      console.error(error);
    }
  }

  const PatchUser = async () => {
    setIsLoading(true);
    const formData = {
      firstName: user?.firstName ?? userData.firstName,
      lastName: user?.lastName ?? userData.lastName,
      identifier: user?.identifier ?? userData.identifier,
      phone: formatPhoneNumber(user?.phone ?? userData?.profile?.phone),
      address: userData?.profile?.address,
      applicationType: "WALLET",
      role: userData?.role?.id,
    };
    await requestAuthPatch(`users/${userData?.id}`, formData).then((res) => {
      if (res.error) {
        setIsLoading(false);
        toastNotify(res.message[0], "error");
      } else {
        if (!_.isEmpty(res)) toastNotify(t("profile.updateMsg"), "success");
        setIsLoading(false);
      }
    });
  };

  const UpdateUser = async () => {
    if (user?.identifier !== userData?.identifier) {
      setShowConfirmation(true);
    } else {
      await PatchUser();
      fetchAuthData();
    }
  };

  return (
    <>
      <ModalLoading showModal={isLoading} setShowModal={setIsLoading} />
      <ModalConfirmation
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        ConfirmFunction={async () => {
          await PatchUser();
          setShowConfirmation(false);
          logout();
        }}
        title="Konfirmasi Perubahan Email"
        text="Apakah Anda yakin ingin mengganti email Anda? Perubahan ini akan mengharuskan Anda untuk login ulang demi keamanan akun Anda."
      />
      <Header title="Profile" transparent />
      <img src={bg} alt="" className="absolute top-0 -z-50 -my-10 w-full" />

      <Container>
        <div className="px-4 py-20">
          <div className="space-y-5">
            <div className="flex justify-center">
              <div className="m-1.5">
                {!_.isEmpty(userData?.outlet?.retailer?.logo) ? (
                  <img
                    className="rounded-full shadow"
                    src={userData?.outlet?.retailer?.logo}
                    width="100"
                    height="100"
                    alt="Avatar"
                  />
                ) : (
                  <div className="flex items-center justify-center rounded-full bg-[#4CA6F8] px-2 py-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-24 w-24 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                )}
              </div>
            </div>

            <div>
              {/* <div className="flex items-center justify-between">
                <h2 className="font-medium text-gray-700">Account</h2>
              </div> */}
              {/* Data Admin */}
              <div>
                {/* <h2 className="font-medium text-gray-700">Data Admin</h2> */}
                <form className="mt-4">
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-4">
                      <InputIcon
                        icon={userIcon}
                        name="firstName"
                        placeholder={t("profile.firstName")}
                        label="Nama Depan"
                        value={user?.firstName ?? userData.firstName}
                        onChange={(e) =>
                          setUser((prevState) => ({
                            ...prevState,
                            [e.target.name]: e.target.value,
                          }))
                        }
                        disabled={!userData?.role?.walletAdmin}
                      />
                      <FormInput
                        name="lastName"
                        label="Nama Belakang"
                        placeholder={t("profile.lastName")}
                        type="text"
                        value={user?.lastName ?? userData.lastName}
                        onChange={(e) =>
                          setUser((prevState) => ({
                            ...prevState,
                            [e.target.name]: e.target.value,
                          }))
                        }
                        disabled={!userData?.role?.walletAdmin}
                      />
                    </div>
                    <InputIcon
                      name="phone"
                      value={formatPhoneNumber(
                        user?.phone ?? userData?.profile?.phone,
                      )}
                      onChange={(e) =>
                        setUser((prevState) => ({
                          ...prevState,
                          [e.target.name]: e.target.value,
                        }))
                      }
                      disabled={!userData?.role?.walletAdmin}
                      icon={whatsapp}
                      label="Nomor WhatsApp"
                      // prefix="+62"
                      type="number"
                      placeholder={t("signin.waPlaceholder")}
                    />
                    {/* <div className="relative">
                      <input
                        name="phone"
                        className="form-input h-12 w-full pl-6"
                        type="tel"
                        value={formatPhoneNumber(
                          user?.phone ?? userData?.profile?.phone,
                        )}
                        onChange={(e) =>
                          setUser((prevState) => ({
                            ...prevState,
                            [e.target.name]: e.target.value,
                          }))
                        }
                        disabled={!userData?.role?.walletAdmin}
                      />
                      <div className="pointer-events-none absolute inset-0 right-auto flex items-center">
                        <span className="px-3 text-sm font-medium text-gray-400">
                          +
                        </span>
                      </div>
                    </div> */}
                    {/* <input
                      name="identifier"
                      placeholder={t("profile.adminEmail")}
                      className="form-input h-12 w-full"
                      type="email"
                      value={user?.identifier ?? userData.identifier}
                      onChange={(e) =>
                        setUser((prevState) => ({
                          ...prevState,
                          identifier: e.target.value,
                        }))
                      }
                      disabled={!userData?.role?.walletAdmin}
                    /> */}
                    <InputIcon
                      placeholder="Admin Email"
                      icon={mail}
                      onChange={(e) =>
                        setUser((prevState) => ({
                          ...prevState,
                          identifier: e.target.value,
                        }))
                      }
                      label="Email Administrator"
                      value={user?.identifier ?? userData.identifier}
                      disabled={!userData?.role?.walletAdmin}
                    />
                  </div>
                </form>
              </div>
            </div>
            <>
              <div>
                {/* <div className="flex items-center justify-between">
                  <h2 className="font-medium text-gray-700">
                    {t("profile.bankAcc")}
                  </h2>
                </div> */}
                {/* banner message to update bank account data if the data does not match the bank master data */}
                {isBannerShow.renew_bank_data && (
                  <div className="mt-4">
                    <div
                      className={`flex items-center space-x-2 rounded bg-yellow-100 px-3 py-2 text-yellow-600`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="h-4 w-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                        />
                      </svg>
                      <span className="text-sm">
                        {t("profile.bankWarning")}
                      </span>
                    </div>
                  </div>
                )}
                {isBannerShow.disable_change_data && (
                  <div className="mt-4">
                    <div
                      className={`flex items-center space-x-2 rounded bg-yellow-100 px-3 py-2 text-yellow-600`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="h-4 w-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                        />
                      </svg>
                      <span className="text-sm">{t("profile.memberWarn")}</span>
                    </div>
                  </div>
                )}
                {/* form bank account details */}
                <div className="my-8">
                  <CardSection title={t("profile.bankAcc")}>
                    <div className="space-y-2">
                      <div className="flex justify-between text-xs">
                        <p className="text-monochrome-300">Nama Bank</p>
                        <p className="text-monochrome-400">
                          {inputBank?.bankName ?? "-"}
                        </p>
                      </div>
                      <div className="flex justify-between text-xs">
                        <p className="text-monochrome-300">Nomor Rekening</p>
                        <p className="text-monochrome-400">
                          {inputBank?.accountNumber ?? "-"}
                        </p>
                      </div>
                      <div className="flex justify-between text-xs">
                        <p className="text-monochrome-300">
                          Nama Pemilik Rekening
                        </p>
                        <p className="text-end text-monochrome-400">
                          {inputBank?.name ?? "-"}
                        </p>
                      </div>
                    </div>
                  </CardSection>
                </div>
              </div>
            </>

            {/* BUTTON GROUP */}
          </div>
        </div>
      </Container>
      <div className="fixed bottom-0 w-full bg-white">
        <div className="mx-auto flex max-w-screen-xl flex-col space-y-2 px-4 py-2">
          {userData.role.walletAdmin && (
            <Button
              label={t("profile.save")}
              variant="gradient"
              onClick={UpdateUser}
              disabled={false}
            />
          )}
        </div>
      </div>
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
}

export default withAuth(Profile);
